/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { switchMap, map } from 'rxjs/operators';

import { HmsLocation, HmsLocationData } from '../../../interfaces/masters/hms-location';
import { HmsLocationApi } from '../api/hms-location.api';

@Injectable()
export class HmsLocationService extends HmsLocationData {

  constructor(private api: HmsLocationApi) {
    super();
  }



  list(url: string): Observable<HmsLocation[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<HmsLocation>{
      return this.api.getById(url);
  }

  create(url: string, data:HmsLocation): Observable<HmsLocation> {
    return this.api.add(url,data);
  }

  update(url: string, data:HmsLocation): Observable<HmsLocation> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
